/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from 'src/shared/app/authentication/component/base/AuthenticationBase.style';
import messages from 'src/shared/app/signup/l10n/baseSignupL10n';
import authMessages from 'src/shared/app/authentication/l10n/authenticationL10n';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { passwordSupportRoute } from 'src/shared/app/base/route/setting/routeSettings';
import DiscreteLink from 'src/shared/ui/component/link/DiscreteLink';

type Props = {
  isPasswordSet: boolean,
  forgotPasswordURL: ?string,
  supportEmail: string,
};

const useStyles = createUseStyles(styles);

const SignupAuthenticationHelperDumb = ({
  isPasswordSet,
  forgotPasswordURL,
  supportEmail,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const [passwordSupportPath] = useRoutes(passwordSupportRoute);

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classes.support}>
      {isPasswordSet ? (
        <DiscreteLink href={forgotPasswordURL || passwordSupportPath}>
          {intl.formatMessage(authMessages.forgotPasswordLink)}
        </DiscreteLink>
      ) : (
        <DiscreteLink href={`mailto:${supportEmail}`}>
          {intl.formatMessage(messages.helper)}
        </DiscreteLink>
      )}
    </div>
  );
};

export default compose(React.memo)(SignupAuthenticationHelperDumb);
